module.exports = __webpack_public_path__ + "static/media/442GriffinStNW_2018-06-05_36.49c5de4c.jpg";